module.exports = __webpack_public_path__ + "img/douyin.f34b5216.png";